import { render, staticRenderFns } from "./CromisCardStatistic.vue?vue&type=template&id=9fbbb5f0"
import script from "./CromisCardStatistic.vue?vue&type=script&lang=js"
export * from "./CromisCardStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports